const COLORS = {
  primary: "#E7481E",
  primaryOpacity: (color) => { return `rgba(24, 29, 72,${color || 0.50})` },  
  secondary: "#5c8d00",
  secondaryOpacity: (color) => { return `rgba(32, 42, 93,${color || 0.50})` },
  tertiary: "#f89520",
  tertiaryOpacity: (color) => { return `rgba(0, 99, 188,${color || 0.50})` },

  notificationSuccess:'#cee6d6',
  notificationWarning:'#ece6bb',
  notificationError:'#ff657a',
  notificationComplete:'#ADD8E6', 
  notificationCompleteDark:'#3a9fbf',
  //basics colors
  red: "red",
  error: "#c95159",
  success: "#00a000",
  warning:"#FFCC00",
  white: '#ffffff',
  whiteOpacity: 'rgba(0, 0, 0,0.75)',
  snow: '#f2f6ff',
  black: '#231f20',
  gray: "#58595b",
  grayPlaceholder: '#A9A9AC',
  lightGray: "#DCDCDC",
  fieldGray: "#E6EAEE",
  fieldGrayInput:"#BDBDBD"
}

export default COLORS
